module.exports = __webpack_public_path__ + "img/ring_y_s_1_null@3x.e7b69729.png";